import { useContext, useState } from 'react';
import RankOneIcon from '../../assets/icons/RankOneIcon';
import RankThreeIcon from '../../assets/icons/RankThreeIcon';
import RankTwoIcon from '../../assets/icons/RankTwoIcon';
import { useLocation } from 'react-router-dom';
import { useGlobalState } from '../../contexts/GlobalState';
import { AuthContext } from '../../contexts/AuthContext';

import GreenpillPagination from './GreenpillPagination';
import { formatNumber } from '../../helpers/formatNumber';
import Loader from '../../ui/Loader';
import SubHeading from '../../ui/SubHeading';
import TopInLead from '../../assets/icons/TopInLead';
import notUpdated from '../../assets/greenpill/notupdated.png';
import AvatarImage from '../../ui/AvatarImage';
import Table from '../../ui/TableGreenpill';
import Pagination from '../../ui/Pagination';
const defaultAvatar = '../../assets/images/defaultAvatar.png';

const ranks = {
    1: (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.0837 13.7396L12.5003 11.9062L14.9066 13.7396L13.9899 10.7708L16.4066 8.85417H13.4482L12.5003 5.92708L11.5524 8.85417H8.59408L11.0003 10.7708L10.0837 13.7396ZM20.8337 9.89583C20.8337 5.29167 17.1045 1.5625 12.5003 1.5625C7.89616 1.5625 4.16699 5.29167 4.16699 9.89583C4.16699 12.0104 4.95866 13.9271 6.25033 15.3958V23.4375L12.5003 21.3542L18.7503 23.4375V15.3958C20.042 13.9271 20.8337 12.0104 20.8337 9.89583ZM12.5003 3.64583C15.9482 3.64583 18.7503 6.44792 18.7503 9.89583C18.7503 13.3437 15.9482 16.1458 12.5003 16.1458C9.05241 16.1458 6.25033 13.3437 6.25033 9.89583C6.25033 6.44792 9.05241 3.64583 12.5003 3.64583ZM12.5003 19.2708L8.33366 20.3333V17.1042C9.56283 17.8125 10.9795 18.2292 12.5003 18.2292C14.0212 18.2292 15.4378 17.8125 16.667 17.1042V20.3333L12.5003 19.2708Z"
                fill="#C27803"
            />
        </svg>
    ),
    2: (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.0837 13.7396L12.5003 11.9062L14.9066 13.7396L13.9899 10.7708L16.4066 8.85417H13.4482L12.5003 5.92708L11.5524 8.85417H8.59408L11.0003 10.7708L10.0837 13.7396ZM20.8337 9.89583C20.8337 5.29167 17.1045 1.5625 12.5003 1.5625C7.89616 1.5625 4.16699 5.29167 4.16699 9.89583C4.16699 12.0104 4.95866 13.9271 6.25033 15.3958V23.4375L12.5003 21.3542L18.7503 23.4375V15.3958C20.042 13.9271 20.8337 12.0104 20.8337 9.89583ZM12.5003 3.64583C15.9482 3.64583 18.7503 6.44792 18.7503 9.89583C18.7503 13.3437 15.9482 16.1458 12.5003 16.1458C9.05241 16.1458 6.25033 13.3437 6.25033 9.89583C6.25033 6.44792 9.05241 3.64583 12.5003 3.64583ZM12.5003 19.2708L8.33366 20.3333V17.1042C9.56283 17.8125 10.9795 18.2292 12.5003 18.2292C14.0212 18.2292 15.4378 17.8125 16.667 17.1042V20.3333L12.5003 19.2708Z"
                fill="#B3BAC7"
            />
        </svg>
    ),
    3: (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.0837 13.7396L12.5003 11.9062L14.9066 13.7396L13.9899 10.7708L16.4066 8.85417H13.4482L12.5003 5.92708L11.5524 8.85417H8.59408L11.0003 10.7708L10.0837 13.7396ZM20.8337 9.89583C20.8337 5.29167 17.1045 1.5625 12.5003 1.5625C7.89616 1.5625 4.16699 5.29167 4.16699 9.89583C4.16699 12.0104 4.95866 13.9271 6.25033 15.3958V23.4375L12.5003 21.3542L18.7503 23.4375V15.3958C20.042 13.9271 20.8337 12.0104 20.8337 9.89583ZM12.5003 3.64583C15.9482 3.64583 18.7503 6.44792 18.7503 9.89583C18.7503 13.3437 15.9482 16.1458 12.5003 16.1458C9.05241 16.1458 6.25033 13.3437 6.25033 9.89583C6.25033 6.44792 9.05241 3.64583 12.5003 3.64583ZM12.5003 19.2708L8.33366 20.3333V17.1042C9.56283 17.8125 10.9795 18.2292 12.5003 18.2292C14.0212 18.2292 15.4378 17.8125 16.667 17.1042V20.3333L12.5003 19.2708Z"
                fill="#D03801"
            />
        </svg>
    ),
};

export function GreenpillLeaderboardTable({
    className,
    leaderboardData,
    currentPage,
    myLeaderDetails,
    setCurrentPage,
    loading,
    totalEntries,
    selectedLandscapes,
    color,
    entriesPerPage,
    entriesHandler,
}) {
    const [fetchedDetails, setFetchedDetails] = useState({});
    const [loadingRows, setLoadingRows] = useState({});
    const location = useLocation();
    const isLeaderboard = location.pathname.endsWith('leaderboard');
    const { state } = useGlobalState();
    const { state: authState } = useContext(AuthContext);
    const userProfile = authState?.user[0];
    console.log(userProfile, 'profileleader');

    const contracts = state?.landscapes.flatMap((l) =>
        l?.contractAddresses?.map((obj) => ({
            ...obj,
            collectionNumber: l?.nftCollectionNumber,
        }))
    );

    const redStateURIs = state?.landscapes
        .flatMap((l) => [l?.stateURIs?.[0], l?.stateURIs?.[1], l?.stateURIsForSolana?.[0], l?.stateURIsForSolana?.[1]])
        .filter(Boolean);

    const orangeStateURIs = state?.landscapes
        .flatMap((l) => [l?.stateURIs?.[2], l?.stateURIs?.[3], l?.stateURIsForSolana?.[2], l?.stateURIsForSolana?.[3]])
        .filter(Boolean);

    const greenStateURIs = state?.landscapes
        .flatMap((l) => [
            l?.stateURIs?.[4],
            l?.stateURIsForSolana?.[4],
            ...(l?.shockStateURIs || []),
            ...(l?.shockStateURIsForSolana || []),
        ])
        .filter(Boolean);

    const renderRow = (leaderboard, isMine = false) => {
        const myRow = leaderboardData?.find((m) => m?.username === leaderboard?.username) || {
            ...leaderboard,
            ...{
                totalImpactPoints: 0,
                amountFundedInUSD: 0,
                greenpillCount: 0,
                username: userProfile.userName,
                profileImage: userProfile.profileImage,
                rank: '-',
            },
        };

        return (
            <Table.Row
                rowClassName={isMine ? 'border border-[#326F58] shadow-border-green rounded-full' : ''}
                key={myRow?.userName}
            >
                <div className={`  text-tSecondary   self-center justify-self-center`}>
                    {myRow?.rank <= 3 ? ranks[myRow?.rank] : myRow?.rank ?? '-'}
                </div>
                <div className="text-tsPrimary flex  items-center space-x-2 col-span-4">
                    <img
                        className={` w-9 h-9 object-cover rounded-[50%] ${className} `}
                        src={myRow?.profileImage ? myRow?.profileImage : notUpdated}
                        alt="coimg"
                    />
                    <span className="truncate">{myRow?.username}</span>
                </div>
                <div className=" text-tsPrimary col-span-3 self-center justify-self-start">
                    {formatNumber(myRow?.totalImpactPoints)}
                </div>

                <div className=" text-tsPrimary self-center justify-self-start col-span-2 ">
                    {myRow?.greenpillCount}
                </div>
            </Table.Row>
        );
    };

    return (
        <div className="overflow-auto px-2 pl-3  main">
            <Table whiteCardClassName="" className="gap-8 " cols="grid-cols-10">
                <Table.Header>
                    <p className="text-base  justify-self-center  font-semibold text-tsPrimary">Rank</p>
                    <p className="text-base col-span-4 font-semibold text-tsPrimary">Name</p>
                    <p className="text-base  col-span-3 font-semibold text-tsPrimary">Impact Points</p>
                    <p className="text-base col-span-2 font-semibold text-tsPrimary">Greenpills</p>
                </Table.Header>
                {loading ? (
                    <div className="flex items-center justify-center w-full pt-10 overflow-hidden">
                        <Loader fillColor="fill-[#326F58]" />
                    </div>
                ) : leaderboardData?.length > 0 ? (
                    [...leaderboardData.map((l, i) => renderRow(l, i === 0 ? true : false))]
                ) : (
                    <Table.Row rowClassName={'border border-[#326F58] shadow-border-green rounded-full'}>
                        <div className={`  text-tSecondary   self-center justify-self-center`}>-</div>
                        <div className="text-tsPrimary flex  items-center space-x-2 col-span-4">
                            <img
                                className={` w-9 h-9 object-cover rounded-[50%] ${className} `}
                                src={userProfile?.profileImage ? userProfile?.profileImage : notUpdated}
                                alt="coimg"
                            />
                            <span className="text-sm truncate font-medium">{userProfile?.userName}</span>
                        </div>
                        <div className=" text-tsPrimary col-span-3 self-center justify-self-start">-</div>

                        <div className=" text-tsPrimary self-center justify-self-start col-span-2 ">-</div>
                    </Table.Row>
                )}
            </Table>
            {totalEntries > 10 && (
                <div className="w-[100%]     mx-auto">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(totalEntries / 10)}
                        entriesPerPage={entriesPerPage}
                        entriesHandler={entriesHandler}
                        onPageChange={setCurrentPage}
                    />
                </div>
            )}
        </div>
    );
}
